import { useEffect, useState } from 'react';
import LargePaymentsTable from './LargePaymentsTable';
import MobilePaymentsTable from './MobilePaymentsTable';

const PaymentsTable = ({ transactions }) => {
    const [screenWidth, setScreenWidth] = useState();

    useEffect(() => {
        if (typeof window !== 'undefined' && !screenWidth) {
            setScreenWidth(window.innerWidth);
        }
    }, [screenWidth]);

    if (screenWidth < 1024) return <MobilePaymentsTable transactions={transactions} />;

    return <LargePaymentsTable transactions={transactions} />;
};

export default PaymentsTable;
